import { Box, CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import type { AccountProfile } from '../api/types';

import { useAuth } from './AuthContext';

type ProtectedRouteProps = {
  children: ReactNode;
  allow?: AccountProfile['role'][];
};

export const ProtectedRoute = ({ children, allow }: ProtectedRouteProps) => {
  const { account, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!account) {
    return <Navigate to="/login" replace />;
  }

  if (allow && !allow.includes(account.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
